import { jsxs as g, jsx as i } from "react/jsx-runtime";
import * as n from "react";
import { useState as G, useId as L, useEffect as M } from "react";
import { W as j } from "../index-PMSPXTub.js";
import { u as z } from "../index-DoOsnuB6.js";
import { P as I, c as A } from "../index-D8UDu4KA.js";
import { a as K, c as R } from "../index-eoE_jzLb.js";
import { u as q } from "../index-BZPx6jYI.js";
import { u as T } from "../index-4vbonZJj.js";
import { P as X } from "../index-CRtCLpV2.js";
import { c as S } from "../clsx-OuTLNxxd.js";
import { L as F } from "../Label-B9Ttm_DE.js";
import '../Checkbox.css';var w = "Checkbox", [W] = A(w), [$, J] = W(w), N = n.forwardRef(
  (e, s) => {
    const {
      __scopeCheckbox: t,
      name: o,
      checked: f,
      defaultChecked: c,
      required: d,
      disabled: a,
      value: h = "on",
      onCheckedChange: b,
      form: p,
      ...C
    } = e, [l, v] = n.useState(null), y = z(s, (r) => v(r)), _ = n.useRef(!1), E = l ? p || !!l.closest("form") : !0, [m = !1, P] = K({
      prop: f,
      defaultProp: c,
      onChange: b
    }), D = n.useRef(m);
    return n.useEffect(() => {
      const r = l == null ? void 0 : l.form;
      if (r) {
        const x = () => P(D.current);
        return r.addEventListener("reset", x), () => r.removeEventListener("reset", x);
      }
    }, [l, P]), /* @__PURE__ */ g($, { scope: t, state: m, disabled: a, children: [
      /* @__PURE__ */ i(
        I.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": u(m) ? "mixed" : m,
          "aria-required": d,
          "data-state": H(m),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: h,
          ...C,
          ref: y,
          onKeyDown: R(e.onKeyDown, (r) => {
            r.key === "Enter" && r.preventDefault();
          }),
          onClick: R(e.onClick, (r) => {
            P((x) => u(x) ? !0 : !x), E && (_.current = r.isPropagationStopped(), _.current || r.stopPropagation());
          })
        }
      ),
      E && /* @__PURE__ */ i(
        Q,
        {
          control: l,
          bubbles: !_.current,
          name: o,
          value: h,
          checked: m,
          required: d,
          disabled: a,
          form: p,
          style: { transform: "translateX(-100%)" },
          defaultChecked: u(c) ? !1 : c
        }
      )
    ] });
  }
);
N.displayName = w;
var O = "CheckboxIndicator", B = n.forwardRef(
  (e, s) => {
    const { __scopeCheckbox: t, forceMount: o, ...f } = e, c = J(O, t);
    return /* @__PURE__ */ i(X, { present: o || u(c.state) || c.state === !0, children: /* @__PURE__ */ i(
      I.span,
      {
        "data-state": H(c.state),
        "data-disabled": c.disabled ? "" : void 0,
        ...f,
        ref: s,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
B.displayName = O;
var Q = (e) => {
  const { control: s, checked: t, bubbles: o = !0, defaultChecked: f, ...c } = e, d = n.useRef(null), a = q(t), h = T(s);
  n.useEffect(() => {
    const p = d.current, C = window.HTMLInputElement.prototype, v = Object.getOwnPropertyDescriptor(C, "checked").set;
    if (a !== t && v) {
      const y = new Event("click", { bubbles: o });
      p.indeterminate = u(t), v.call(p, u(t) ? !1 : t), p.dispatchEvent(y);
    }
  }, [a, t, o]);
  const b = n.useRef(u(t) ? !1 : t);
  return /* @__PURE__ */ i(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: f ?? b.current,
      ...c,
      tabIndex: -1,
      ref: d,
      style: {
        ...e.style,
        ...h,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function u(e) {
  return e === "indeterminate";
}
function H(e) {
  return u(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var U = N, V = B;
const Y = "_checkbox_1wfxv_32", Z = "_shouldHighlightOnChecked_1wfxv_32", ee = "_checked_1wfxv_32", te = "_checkboxBox_1wfxv_53", oe = "_indicator_1wfxv_64", ce = "_checkboxGroup_1wfxv_83", k = {
  checkbox: Y,
  shouldHighlightOnChecked: Z,
  checked: ee,
  checkboxBox: te,
  indicator: oe,
  checkboxGroup: ce
}, pe = ({ children: e, className: s, label: t, ...o }) => (!t && !o["aria-label"] && !o["aria-labelledby"] && console.warn(
  "Checkbox group must provide and `aria-label` if no visible `label` prop is provided. If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility"
), // `...props` last: the type accepts every fieldset attribute, and only three were forwarded, so
// `disabled` (which should disable every control in the group), `name` and `id` were dropped. The
// two aria props are computed above from `label`, so they are spread first and then overridden
// deliberately when the caller set them and there is no visible label.
/* @__PURE__ */ g(
  "fieldset",
  {
    className: S(k.checkboxGroup, s),
    ...o,
    "aria-label": t ? void 0 : o["aria-label"],
    "aria-labelledby": t ? void 0 : o["aria-labelledby"],
    children: [
      t && /* @__PURE__ */ i("legend", { children: t }),
      e
    ]
  }
)), me = ({
  checked: e,
  children: s,
  className: t,
  onCheckedChange: o,
  shouldHighlightOnChecked: f = !0,
  ...c
}) => {
  const [d, a] = G(e), h = L();
  return M(() => {
    a(e);
  }, [e]), /* @__PURE__ */ g(
    F,
    {
      className: S(
        k.checkbox,
        {
          [k.checked]: d,
          [k.shouldHighlightOnChecked]: f
        },
        t
      ),
      "data-cxy-name": "checkbox",
      id: h,
      children: [
        /* @__PURE__ */ i(
          U,
          {
            "aria-labelledby": h,
            ...c,
            checked: d,
            className: k.checkboxBox,
            onCheckedChange: (b) => {
              o == null || o(b), a(b);
            },
            children: /* @__PURE__ */ i(V, { className: k.indicator, children: /* @__PURE__ */ i(j, { color: "blue", size: "xsm" }) })
          }
        ),
        s
      ]
    }
  );
};
export {
  me as Checkbox,
  pe as CheckboxGroup
};
